<template>
    <div class="line-chart">
      <apexchart
      ref="chart"
        :id="id"
        :options="chartOptions"
        :series="series"
      ></apexchart>
    </div>
  </template>

<script>
import VueApexCharts from 'vue3-apexcharts'
import { onMounted, ref, computed } from 'vue'
import { useStore } from 'vuex'

export default {
  name: 'LineChart',
  props: ['id', 'series', 'title', 'movements', 'colors'],
  components: {
    apexchart: VueApexCharts
  },
  setup (props, context) {
    const store = useStore()
    const chart = ref(null)

    const chartOptions = computed(() => {
      const isDarkMode = store.state.theme.currentTheme === 'night'
      return {
        chart: {
          background: 'transparent',
          id: props.id,
          type: 'line',
          zoom: {
            type: 'xy',
            enabled: true
          },
          animations: {
            enabled: false
          },
          toolbar: {
            autoSelected: 'zoom',
            export: {
              csv: {
                headerCategory: 'Time',
                dateFormatter (timestamp) {
                  return timestamp + 'ㅤ'
                }
              }
            },
            tools: {
              zoomin: false,
              zoomout: false
            }
          }
        },
        xaxis: {
          type: 'numeric'
        },
        yaxis: {
          decimalsInFloat: 2
        },
        title: {
          text: props.title,
          style: {
            fontSize: '20px'
          }
        },
        stroke: {
          width: 1.5
        },
        annotations: {
          xaxis: props.movements
        },
        theme: {
          mode: isDarkMode ? 'dark' : 'light',
          palette: 'palette4'
        },
        colors: props.colors,
        legend: {
          showForSingleSeries: true
        }
      }
    })
    onMounted(() => {
      context.emit('chartsLoaded')
    })

    return {
      chartOptions,
      chart
    }
  }
}
</script>

  <style>
  .line-chart {
    width: 100%;
  }

  .chart-actions {
    display: flex;
    justify-content: space-between;
  }

  .revert-button {
    display: flex;
    align-items: center;
    background-color: transparent !important;
  }

  .revert-button .el-icon {
    margin-right: 8px; /* Add some space between the icon and text */
  }

  body[data-theme=night] .el-button.revert-button {
    background-color: transparent !important;
      color: white !important;
  }
  </style>
